import React, { useState } from 'react';

const WpMarketing_Faq = () => {
    const faqs = [
        {
            q: "What is WhatsApp Marketing for Government?",
            a: "It is the use of WhatsApp Business API to provide citizen services, alerts, schemes, and grievance redressal directly on WhatsApp in a secure and scalable way."
        },
        {
            q: "How is it different from normal WhatsApp or SMS?",
            a: "Unlike SMS or normal WhatsApp, the API allows verified government numbers with Green Tick, automated chatflows, broadcasts to lakhs of citizens, and detailed analytics."
        },
        {
            q: "Do we need a new WhatsApp number for API?",
            a: "Yes. A fresh number is required which is not registered on WhatsApp App. Existing official helpline numbers can be migrated if eligible."
        },
        {
            q: "How long does onboarding take?",
            a: "Usually 5–10 business days after Meta verification and KYC. Our team provides full onboarding support."
        },
        {
            q: "What kind of services can be automated?",
            a: "Citizen FAQs, scheme registrations, health updates, exam alerts, payment reminders, grievance tracking, and multilingual awareness campaigns."
        },
        {
            q: "Can WhatsApp be integrated with government portals?",
            a: "Yes. Websites, CRMs, and payment gateways can be integrated via APIs and webhooks so that citizens get real-time updates."
        },
        {
            q: "How secure is citizen data?",
            a: "All messages are end-to-end encrypted. The platform follows government IT guidelines, role-based access, audit logs, and regional data protection laws."
        },
        {
            q: "Do you support multi-language communication?",
            a: "Yes. Departments can create chatflows and templates in Hindi, English, Bangla, Urdu, Nepali, and other regional languages for inclusivity."
        }
    ];

    const [openIndex, setOpenIndex] = useState(0); // first open by default

    const toggle = (i) => setOpenIndex((prev) => (prev === i ? -1 : i));

    return (
        <section
            className="py-5 position-relative mb-5"
            style={{
                overflow: 'hidden',
                marginTop: "70px"
            }}
        >
            {/* Styles for FAQ UI */}
            <style>{`
             .faq-card {
            background: linear-gradient(135deg, #dce7fa, #fefefe);
           border: 1px solid #dae6fc;
           border-radius: 12px;
           padding: 18px 20px;
           display: flex;
           justify-content: space-between;
          align-items: flex-start;
          gap: 16px;
          transition: box-shadow 220ms ease, transform 220ms ease, background 220ms ease;
          cursor: pointer;
          }
  
          .faq-q {
            margin: 0;
            font-family: Lato;
            font-size: 20px;
            font-weight: 600;
            color: #242121ff;
            line-height: 1.3;
          }
          .faq-a {
            margin: 8px 0 0 0;
            font-family: Lato;
            font-weight: 400;
            font-size: 1.12rem;
            color: #413e3eff;
            line-height: 1.2;
            overflow: hidden;
            max-height: 0;
            opacity: 0;
            transition: max-height 320ms ease, opacity 240ms ease, margin 240ms ease;
          }
          .faq-a.open {
            max-height: 220px; /* large enough for content */
            opacity: 1;
            margin-top: 10px;
          }
  
          /* Right circular arrow button (3D-ish) */
          
          .arrow-btn {
           flex: 0 0 auto;
           width: 26px;
           height: 26px;
           border-radius: 999px;
           display: grid;
           place-items: center;
           border: 2px solid #3b5c92; 
           background: radial-gradient(
              120% 120% at 30% 20%,
              #ffffff 0%,
              #f8faff 60%,   
              #edf3fa 100%  
          );
          box-shadow:
          inset 0 -2px 0 rgba(0, 0, 0, 0.05), 
          inset 0 1px 0 rgba(255, 255, 255, 0.8);
          transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
          }
  
          .arrow-icon {
            width: 16px;
            height: 16px;
            fill: #0F2B54; /* navy */
            transition: transform 220ms ease;
          }
          .arrow-rotated {
            transform: rotate(180deg); /* down ↔ up */
          }
  
          /* spacing between cards */
          .faq-gap { height: 16px; }
        `}</style>

            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative mb-5"
                style={{ maxWidth: '74%', zIndex: 1 }}
            >
                {/* Heading */}
                <div className="mb-5">
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Frequently ask questions
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        Quick answers on <span style={{ color: "#054E91", fontWeight: 700 }}>Vertex</span>{" "}
                        <span
                            style={{
                                background: "linear-gradient(90deg, #1F88E5 0%, #6EC9FF 100%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                display: "inline-block",
                                fontWeight: 700
                            }}
                        >
                            Suite's
                        </span> automation, templates, pricing and uses- so you can start fast.
                    </p>
                </div>

                {/* FAQ list */}
                <div>
                    {faqs.map((item, i) => {
                        const isOpen = openIndex === i;
                        return (
                            <div key={i}>
                                <div
                                    className="faq-card"
                                    onClick={() => toggle(i)}
                                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggle(i)}
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={isOpen}
                                >
                                    <div style={{ flex: 1 }}>
                                        <h5 className="faq-q">{item.q}</h5>
                                        <p className={`faq-a ${isOpen ? 'open' : ''}`}>{item.a}</p>
                                    </div>

                                    {/* Right circular arrow */}
                                    <div
                                        className="arrow-btn"
                                        aria-hidden="true"
                                    >
                                        {/* Down arrow SVG that rotates to up when open (gives the “3D” pop with shadows above) */}
                                        <svg
                                            viewBox="0 0 24 24"
                                            className={`arrow-icon ${isOpen ? 'arrow-rotated' : ''}`}
                                        >
                                            {/* simple chevron/triangle mix for a crisp “straight bottom arrow” look */}
                                            <path d="M12 16c-.3 0-.6-.1-.8-.3l-6-6a1.1 1.1 0 0 1 1.6-1.6L12 13.7l5.2-5.6a1.1 1.1 0 1 1 1.6 1.6l-6 6c-.2.2-.5.3-.8.3z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* gap between cards */}
                                {i !== faqs.length - 1 && <div className="faq-gap" />}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default WpMarketing_Faq